import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const CommAutoCSIOMpoiWrapper = Loadable(
  lazy(() =>
    import("./CommAutoCSIOMpoiWrapper").then(({ CommAutoCSIOMpoiWrapper }) => ({
      default: CommAutoCSIOMpoiWrapper,
    }))
  )
);
const CommAutoMpoiWrapper = Loadable(
  lazy(() =>
    import("./CommAutoMpoiWrapper").then(({ CommAutoMpoiWrapper }) => ({
      default: CommAutoMpoiWrapper,
    }))
  )
);

export const CommAutoMpoiWrapperRouter = [
  {
    path: `/comm-automobile-policy/:customerId/csio-mpoi/:customerPolicyId/`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoCSIOMpoiWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/comm-automobile-policy/:customerId/csio-mpoi/:customerPolicyId/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoMpoiWrapper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/comm-automobile-policy/:customerId/csio-mpoi/:customerPolicyId/manage/:requestUuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoMpoiWrapper />
      </AuthorizedRoute>
    ),
  },
];
